/* eslint-disable no-undef */
import axios from "axios";
import { Message } from "@arco-design/web-react";
import { getTokenToLocalStorage } from "@/utils/token";
import { whiteListRequest } from "@/config/whiteLIst";
// 需要跳过 Token 校验的路由

const http = axios.create({
  // baseURL:
  //   process.env.REACT_APP_MODE === "development"
  //     ? ""
  //     : process.env.REACT_APP_PROXY,
  timeout: 100000,
});

let messageIns = null;

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    const requestUrl = config.url;
    config.headers["Aid"] = process.env.REACT_APP_AID ?? 0;
    const isWhitelisted = whiteListRequest.some((route) => {
      return route === requestUrl;
    });
    // 跳过 Token 验证和头部附加
    if (isWhitelisted) {
      if (window.electron) {
        config.headers["Device"] = "web_client";
      }
      return config;
    }
    const token = getTokenToLocalStorage();
    if (!token) {
      window.location.href = "/login";
      return Promise.reject("没有找到 Token，请重新登录");
    }
    try {
      const tokenParts = token.split(".");
      if (tokenParts.length !== 3) {
        throw new Error("Token 格式不正确");
      }
      const payload = tokenParts[1];
      const decodedPayload = JSON.parse(
        // 特殊字符处理 解决非 ASCII 字符或转义字符 parse 报错
        decodeURIComponent(
          atob(payload)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        )
      );

      // exp 时间戳
      const exp = decodedPayload.exp;

      const currentTime = Math.floor(Date.now() / 1000);
      // Token 是否过期
      if (exp < currentTime) {
        window.location.href = "/login";
        if (!messageIns) {
          messageIns = Message.error("Token 已过期，请重新登录");
          setTimeout(() => {
            messageIns = null;
          }, 2000);
        }

        return Promise.reject("Token 已过期，请重新登录");
      } else {
        if (window.electron) {
          config.headers["Device"] = "web_client";
        }
        config.headers["Token"] = `${token}`;
        return config;
      }
    } catch (error) {
      window.location.href = "/login";
      if (!messageIns) {
        messageIns = Message.error({
          content: "Token 无效，请重新登录",
          duration: 2000,
        });

        setTimeout(() => {
          messageIns = null;
        }, 2000);
      }
      return Promise.reject("Token 无效，请重新登录");
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    if (response.config.url.includes("graphql")) {
      if (response.data.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response.data.message);
      }
    }
    if (response.headers["content-type"] === "text/event-stream") {
      return Promise.resolve(response.data);
    }

    if (response.status === 200 || response.status === 207) {
      if (response.data?.code === 0) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response.data?.message);
      }
    }
    return Promise.reject("请求失败");
  },
  (error) => {
    console.log("error", error, messageIns);

    if (error.response && error.response.status === 401) {
      if (!messageIns) {
        messageIns = Message.error("Token 已过期，请重新登录");
        setTimeout(() => {
          messageIns = null;
        }, 2000);
      }

      window.localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (error.response && error.response.status === 400) {
      return Promise.reject(error.response.data.message);
    }

    return Promise.reject(error);
  }
);

// window.$ = {};
// window.$.ajax = async ({ url, data, success }) => {
//   console.log("请求参数：", url, data);
//   const result = await http.post(url, {
//     datas: JSON.parse(data.datas),
//   });
//   console.log("返回结果：", success, result);

//   return success(result);
// };

export default http;
